import Component from 'e-submission/components/ButtonWithLoading'
export default (hoc) => hoc(Component)
